import { useSearchParams } from 'react-router-dom'

/**
 * Subscription Redirect Page
 *
 * Shows a button to return to the mobile app after LemonSqueezy checkout.
 * This is required because:
 * 1. LemonSqueezy only accepts HTTP/HTTPS redirect URLs, not deep links (treu://)
 * 2. Safari blocks automatic JavaScript redirects to custom URL schemes for security
 * 3. User must click a link to trigger the deep link redirect
 *
 * Flow:
 * 1. LemonSqueezy redirects to: http://localhost:5173/subscription-redirect?status=success
 * 2. This page shows a button with the deep link: treu://subscription/success
 * 3. User taps button, iOS opens the Treu app with the deep link
 */
export default function SubscriptionRedirectPage() {
  const [searchParams] = useSearchParams()
  const status = searchParams.get('status') || 'success'
  const deepLink = `treu://subscription?status=${status}`

  console.log('[SubscriptionRedirect] Deep link ready:', deepLink)

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-paper-0 px-4 py-6 text-center">
      <div className="w-full max-w-sm rounded-lg border border-paper-200 bg-white p-8 shadow-card sm:p-10">
        <h1 className="mb-4 text-xl font-semibold text-ink-900">
          {status === 'success' ? '✓ Payment Successful' : 'Checkout Cancelled'}
        </h1>
        <p className="mb-6 text-ink-600">
          Tap the button below to return to the Treu app
        </p>
        <a
          href={deepLink}
          className="inline-block w-full rounded-md bg-accent-500 px-8 py-4 text-base font-semibold text-white no-underline transition-colors hover:bg-accent-600"
        >
          Open Treu App
        </a>
        <p className="mt-6 text-sm leading-relaxed text-ink-400">
          Your subscription has been updated successfully
        </p>
      </div>
    </div>
  )
}
